import React from 'react';
import { Button } from '@plerionhq/design-system';
import { ExtendedMarkdown } from '../../MessageContent/ExtendedMarkdown';

import { useTranslation } from 'react-i18next';

interface RoiReportMarkdownProps {
  content: string;
  month?: string;
}

export const RoiReportMarkdown: React.FC<RoiReportMarkdownProps> = ({
  content,
  month,
}) => {
  const { t } = useTranslation('pleri/settings');
  if (!content.trim()) {
    return null;
  }

  const handleDownload = () => {
    const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `roi-report-${month ?? 'report'}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <Button
          label={t('downloadReport')}
          variant="secondary"
          onClick={handleDownload}
        />
      </div>
      <div className="prose prose-sm max-w-none">
        <ExtendedMarkdown content={content} />
      </div>
    </div>
  );
};
